import { render, staticRenderFns } from "./QuickLinks.vue?vue&type=template&id=e87a2f72&"
import script from "./QuickLinks.vue?vue&type=script&lang=js&"
export * from "./QuickLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickLinks.vue"
export default component.exports